import React from "react";

const ExamResults = ({ 
  questions, 
  answers, 
  status, 
  usedTime 
}) => {
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  const calculateStats = () => {
    const answered = status.filter((s) => s === "answered").length;
    const marked = status.filter((s) => s === "marked").length;
    const completionRate = Math.round((answered / questions.length) * 100);
    
    return {
      answered,
      marked,
      completionRate,
      totalTime: formatTime(usedTime)
    };
  };

  const renderResponseItem = (question, index) => {
    const userAnswer = answers[index] !== null 
      ? question.options[answers[index]] 
      : "Not Answered";
      
    const isCorrect = answers[index] === question.correct;
    const statusIcon = isCorrect 
      ? <span className="correct">✅</span> 
      : <span className="wrong">❌</span>;

    return (
      <div className="response-item" key={index}>
        <b>Q{index + 1}:</b> {userAnswer} {statusIcon}
      </div>
    );
  };

  const stats = calculateStats();

  return (
    <div className="result-screen">
      <div className="result-card">
        <h2 className="result-title">🎉 Assessment Completed Successfully!</h2>
        
        <div className="stats-grid">
          <div className="stat-box">
            <div className="stat-number">{stats.answered}</div>
            <div>Questions Answered</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">{stats.completionRate}%</div>
            <div>Completion Rate</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">{stats.totalTime}</div>
            <div>Total Time</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">{stats.marked}</div>
            <div>Marked for Review</div>
          </div>
        </div>
        
        <div className="responses">
          <h4>📝 Your Responses:</h4>
          <div id="response-list">
            {questions.map((question, index) => 
              renderResponseItem(question, index)
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExamResults;